// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__29TT2","small":"Tag_small__26Rys"};